	
	
import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ClearSharpIcon from '@mui/icons-material/ClearSharp';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
export default class PromotionForm extends Component {

   constructor(props) {
      super(props);
	  
      this.state = {ReviewData:[],fb_isapprove:0,fb_message:'',redirect:false,fb_course:0,fb_id:'',fb_staff:0,fb_experience:0,fb_trainers:0,fbid:'',
		  
	
	  }
	         this.updateDonenewParent = this.updateDonenewParent;
	  
   }
      



	updateDonenewParent = (text) => {this.componentDidMount();  }


   componentDidMount() {
  
	this.CustomerReviewGetData()
	
		
}



CustomerReviewGetData(){
	
	   axios.get(Serverurl+'ajaxfeedback.php?action=getall&fb_isapprove=1&userid='+localStorage.getItem("AYUserid"))

  .then(resp => {  
		
 	
			this.setState({  
			  ReviewData:resp.data,  
			  

		    });
		
 
    });
	
	
	
	
	
}


     
   myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val}); 
} 
	
	  
	
onchangeHandler= (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val},()=>{this.apicall(); }
  );
}
  
		


onclick1(val){
      
      this.setState({fb_course: val });
	
    }	



onclick2(val){
      
      this.setState({fb_staff: val });
	
    }	
	
	
onclick3(val){
      
      this.setState({fb_experience: val });
	
    }	


onclick4(val){
      
      this.setState({fb_trainers: val });
	
    }	




 
  










  	  
handleSubmit= (event) => {

	 
 let fb_id = this.state.fb_id;
 let fb_course = this.state.fb_course;
 let fb_staff = this.state.fb_staff;
 let fb_experience = this.state.fb_experience;
  let fb_trainers = this.state.fb_trainers;
  let fb_message = this.state.fb_message;

if(fb_course===0)
{
	
	this.setState({errormessage:"Please Rate For course",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


if(fb_staff===0)
{
	
	this.setState({errormessage:"Please Rate For staff",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(fb_experience===0)
{
	
	this.setState({errormessage:"Please Rate For Experience",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(fb_trainers===0)
{
	
	this.setState({errormessage:"Please Rate For Trainers",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(fb_message==="")
{
	
	this.setState({errormessage:"Enter Your Feedback",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

	 var formData = new FormData();

	
	 formData.append('action','insertorupdate')
	 
	 
				
				if(fb_id===0){
					formData.append('fb_id',"0")
					}
				else{
					
					formData.append('fb_id',fb_id)
				
				}
    formData.append('fb_course',fb_course)
	 formData.append('fb_staff',fb_staff)
	 formData.append('fb_experience',fb_experience)
		   formData.append('fb_trainers',fb_trainers)
		   formData.append('fb_message',fb_message)
	
	  		
	  formData.append('userid',1)
	  
	  
 axios.post(Serverurl+"ajaxfeedback.php", formData, {
        }).then(res => {
				if(res.data!=-1)
					{
			

			alert("Thank You for the feedback")	;
					this.ClearData();
					
		
					
				//	this.setState({open:false,btnsavedisbaled:false,btnsavetxt:'Save',});
				
						
							
							
						}
	   });
	  
    				
					
				}
  



ClearData=(e)=>{
	
this.setState({fb_id:0,fb_course:0,fb_message:"",fb_trainers:0,fb_staff:0,fb_experience:0});

}





handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open, 
     errormessage:'',erropen:false,
	  });

		


};



      ReviewAddBox(val){
        this.setState({ fbid: val });  
  
         setTimeout(() => this.refs.AddBranchbox.handleClickOpen(),500);

      }

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	

	  
render() { 
  

 
    
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  return (

<React.Fragment>
		
		<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
		
		
		<div className="feedbackbox">
		
		<div className="feedback-heading">
		<h4>We'd love your feedback</h4>
		<p>Your feedback helps us to know about your experience</p>
		</div>
		  <Stack spacing={1}>
		  
		  <ul>
		  <li>
		  <p>About Course</p>
		      <Rating
        name="fb_course"
        value={this.state.fb_course}
        onChange={(event, newValue) => {
          this.onclick1(newValue)
        }} 
      />
	  </li>
	  
	  <li>
	   <p>About Staff</p>
     	      <Rating className="star"
        name="fb_staff"
        value={this.state.fb_staff}
        onChange={(event, newValue) => {
          this.onclick2(newValue)
        }} 
      />
	  
	  </li>
	  
	  <li>
	  	   <p>Learning Experience</p>
	  	      <Rating
        name="fb_experience"
        value={this.state.fb_experience}
        onChange={(event, newValue) => {
          this.onclick3(newValue)
        }} 
      />
      </li>
	  
	  <li>
	   <p>Trainers</p>
	  	      <Rating
        name="fb_trainers"
        value={this.state.fb_trainers}
        onChange={(event, newValue) => {
          this.onclick4(newValue)
        }} 
      />
     </li>
	 </ul>
	
    </Stack>
	
	
	<div className="message-div">
	 <p> Message</p>

	
		  
	 <TextField name="fb_message" 
	 
	   onChange={this.myChangeHandler} 
	  fullWidth
	   multiline 
	   className="messagebox"
          rows={4}
	   value={this.state.fb_message}
			 
			  
			 inputProps={{tabIndex: "8",maxLength:100}} 
	   InputLabelProps={{ shrink: true }}
                          />
		  
		  
		  


		  
		  
		</div>
		  	
			
			
		<div className="feedback-btn">
          <p className="submitbutton"> 
		  <Button variant="contained" className="feedbtn" onClick={this.handleSubmit}  
		  endIcon={<CheckOutlinedIcon />}>
   Submit
</Button></p>
		 </div>

		  
		  </div>

	
	
	<div className="feedbackbox">	
	
	
{this.state.ReviewData.length>0 &&(

<div className="reviewbox">
	<ul>
	{this.state.ReviewData.map((item,index) => { return ( 
	
	

	<li key={index}>
	
			<div className="review-date">
			
			{item.createdate}
			
			</div>
				
				
			<div className="review-message">
			
	   {item.message}
			 
			
			</div>
	<div className="review-star">
	
	<Rating className="reviewstar"
      
        value={item.Overallrating}
         
      />
	
	</div>
	
	<div className="review-arrow">
		 <Button variant="text" className="popup-cancelbtn"  onClick={()=>{this.ReviewAddBox(item.fb_id)}}  endIcon={<ArrowForwardIosSharpIcon />}>

</Button> 
	
	</div>
	
	  
	  </li>

	
	
	 

	

	 
	
	 );})}
	</ul></div>
	 )}
 <AddBranchbox ref="AddBranchbox" fbid={this.state.fbid}  updateDonenew={this.updateDonenewParent}/>	
</div>
	</React.Fragment>
	
	
	);
	
	
}

}














export  class  AddBranchbox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,Data:[]
	  }
      
  }
  handleClickOpen = (e) => {
 
 this.setState({  
			  open:true,  
			  

		    },()=>{this.Feedbackgetdatabyid();});
		
		


};
HandleCancel=(e)=>{
	this.setState({open:!this.state.open, 
   
	  });	
}

  
  
Feedbackgetdatabyid(){
	axios.get(Serverurl+'ajaxfeedback.php?action=getall&fb_isapprove=1&userid='+localStorage.getItem("AYUserid")+'&fb_id='+this.props.fbid)

  .then(resp => {  
		
 	
			this.setState({  
			  Data:resp.data,  
			  

		    });
		
 
    });
	
}



render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
     	  	<div className="popup-cancelbtn"> <Button variant="text" className="popup-cancelbtn"   onClick={()=>{this.HandleCancel()}} endIcon={<ClearSharpIcon />}>

</Button> </div>

	 <DialogTitle id="form-dialog-title">Feedback</DialogTitle>


<div className="clear"></div>
      <DialogContent>
	  

	
{this.state.Data.length>0 &&(


	<ul>
	{this.state.Data.map((item,index) => { return ( 
	<div className="popupreview">
	<li key={index}>
	
	
	
	 
	
	
	
	  <li>
	   
	  	  
      <p>
       {item.createdate}
         
     </p>
	  
	  </li>
	  
	  
	  <li>
	  	   <p><Rating className="popustar"
      
        value={item.Overallrating}
         
      /></p>
	  
	  </li>
	  
	  
	   <li>
	   
	  	  
      <p className="">
       {item.message}
         
     </p>
	  
	  </li>
	
	
	
	  
	

	
	 </li>
	 
	  </div>
	 );})}
	</ul>
	 )}
	
		 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
 